import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const TotalDisplacementPlot = forwardRef(({ metrics }, ref) => {
  const [positions, setPositions] = useState([]);
  const [totalDisplacementValues, setTotalDisplacementValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let totalDisplacement = [];

    metrics.forEach((metric, i) => {
      positions.push(i + 1);

      totalDisplacement.push(metric.hasOwnProperty("totalDisplacement") ? metric.totalDisplacement : NaN);
    });

    setPositions(positions);
    setTotalDisplacementValues(totalDisplacement);

    return () => {
      setPositions([]);
      setTotalDisplacementValues([]);
    };
  }, [metrics]);

  const totalDisplacementData = {
    labels: positions,
    datasets: [
      {
        label: t("reports_totalDisplacementGraphic"),
        data: totalDisplacementValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_totalDisplacementGraphic_title")}
        Type={Line}
        data={totalDisplacementData}
        axisY={t("reports_totalDisplacementGraphic")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_totalDisplacementDescription_App")}
        isBeta
      />
    </GraphicContainer>
  );
});

export default TotalDisplacementPlot;
